import appModule from './app.module'
appModule.factory('auth', ['$http', '$q', '$window', 'ENV', 'session', 'version', '$rootScope',
    function($http, $q, $window, ENV, session, version, $rootScope) {
        const storage = $window.localStorage;
        const TOKEN_NAME = 'synkedup_token'
        const versionHeader = { 'synkedup-version': `web ${version}` }

        const login = (data) => {
            return $http.post(`${ENV.apiEndpoint}/token`, data, { headers: versionHeader })
                .then((res) => {
                    var token = {
                        access_token: res.data.access_token,
                        refresh_token: res.data.refresh_token,
                        type: res.data.token_type,
                        expires: moment(res.data.expires).toISOString()
                    };
                    storage.setItem(TOKEN_NAME, JSON.stringify(token))
                    return true;
                })
        }

        const logIntoTenant = (targetTenantId) => {
            return $http.post(`${ENV.apiEndpoint}/web/authentication/tenant/${targetTenantId}`, {}, { headers: headers() })
                .then((res) => {
                    var token = {
                        access_token: res.data.access_token,
                        refresh_token: res.data.refresh_token,
                        type: res.data.token_type,
                        expires: moment(res.data.expires).toISOString()
                    };
                    storage.setItem(TOKEN_NAME, JSON.stringify(token))
                    window.location.href = '/#!/'
                    window.location.reload()
                    return true;
                })
        }

        $rootScope.returnToOriginalTenant = async () => {
            await logIntoTenant($rootScope.currentUser.originalTenantId)
        }

        const logout = () => {
            storage.removeItem(TOKEN_NAME)
            session.User = {};
            window.Intercom('shutdown');
            window.posthog.reset();
            window.location.href = "/#!/account";
            window.location.reload();
        }

        const refresh = (refresh_token) => {
            return $http.post(`${ENV.apiEndpoint}/token/refresh`, { ...versionHeader, 'token': refresh_token })
                .then((res) => {
                    var token = {
                        access_token: res.data.access_token,
                        refresh_token: res.data.refresh_token,
                        type: res.data.token_type,
                        expires: Date.now() + parseInt(res.data.expires_in) * 1000
                    };
                    storage.setItem(TOKEN_NAME, JSON.stringify(token));
                    return { 'Authorization': 'Bearer ' + token.access_token };
                })
        }

        const access = () => {
            const token = JSON.parse(storage.getItem(TOKEN_NAME)) || {}
            if (token.access_token && moment(token.expires) > moment()) {
                return $q.resolve({ 'Authorization': 'Bearer ' + token.access_token });
            } else {
                return $q.resolve({});
                return refresh()
            }
        }

        const headers = () => {
            const token = JSON.parse(storage.getItem(TOKEN_NAME)) || {}
            if (token.access_token && moment(token.expires) > moment()) {
                return { ...versionHeader, 'Authorization': 'Bearer ' + token.access_token }
            } else {
                return {}
            }
        }

        const isAuthenticated = () => {
            const token = JSON.parse(storage.getItem(TOKEN_NAME)) || {}
            if (token.access_token && moment(token.expires) > moment()) {
                return true
            }
            return false
        }

        return {
            login: login,
            logout: logout,
            access: access,
            headers: headers,
            isAuthenticated: isAuthenticated,
            logIntoTenant: logIntoTenant
        }

    }
])

